import { Component } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ContactFormComponent } from "../../shared/contact-form/contact-form.component";
import { HeroComponent } from "../../shared/hero/hero.component";
import { CEO_CONFIG } from "../../shared/contact-form/contact-config";
import { ARTICLES } from "../articles";

import { JobOffersComponent } from "../components/job-offers/job-offers.component";
import { PaginationComponent } from "../components/pagination/pagination.component";

@Component({
  selector: "app-newsroom",
  templateUrl: "./newsroom.component.html",
  styleUrls: ["./newsroom.component.scss"],
  imports: [
    FormsModule,
    HeroComponent,
    ContactFormComponent,
    JobOffersComponent,
    PaginationComponent,
  ],
})
export class NewsroomComponent {
  protected readonly CEO_CONFIG = CEO_CONFIG;
  public heroConfig = {
    slogan: "Your dream is our realITy",
    subpageTitle: "newsroom",
    subSlogan: "See what's new with us",
    background: "newsroom-bg",
  };
  public allArticles = ARTICLES;
  public articlesPerPage = 4;
}
